import { Stack, Typography } from "@mui/material";
import { ManagementCompany } from "src/pages/Admin/ManagmentCompanies/types";

interface Props {
	value: ManagementCompany;
}

export default function Option({ value }: Props) {
	return (
		<Stack
			alignItems='center'
			alignSelf='stretch'
			flexDirection='row'
			gap={1}
			justifyContent={"space-between"}
			width={"100%"}
		>
			<Stack alignItems='center' alignSelf='stretch' flexDirection='row' gap={1}>
				<Stack>
					<Typography
						color={"textPrimary"}
						component='span'
						sx={{ whiteSpace: "pre" }}
						variant='subtitle2'
					>
						{value.name}
					</Typography>
					<Stack>
						<Typography color='text.secondary' variant='body2'>
							{value.cif}
						</Typography>
					</Stack>
				</Stack>
			</Stack>
		</Stack>
	);
}
